import React, { useEffect, useState, useCallback, use } from "react";
import "./stakingpool.scss";
import { apiRequest } from "../../api/apiService";
import { useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Loader from "../../shared/Loader";
import { useTokenBalance } from "../Createpool/hooks";
import useWallet from "../../hooks/useWallet";
import { removeCommas } from "../../helper";
import { useStake } from "../../hooks/useStake";
import { fetchPrice } from "../../utils/fetchTokenPrice";
import { useTokenAllowance } from "../../hooks/useTokenAllowance";
import { TabSection } from "./tab";
import ActivitySection from "./activity/ActivitySection";
import ModalManager from "./models/ModalManager";
import { useBondSize } from "../../hooks/useBondSize";
import { useTokenPrice } from "../../hooks/useTokenPrice";
import { ApiUrl } from "../../utils/ApiUrl";
import Tvl from "../../shared/Tvl";
import { useLocation } from "react-router-dom";
import { useTheme } from "../../hooks/ThemeProvider";
import { STAKES, CLAIMEDS } from "../../api/queries";
import { unifarmFactory } from "../../utils/contract";
import { defaultUserProfile } from "../../utils/constant";
import { useParentPoolAPR } from "../../hooks/useParentPoolAPR";
import {
  // calculateAPR,
  calculateChildPoolAPR,
  fun,
} from "../../utils/unifarmAprCalculator";
import { formatUnits } from "viem";
import { set } from "lodash";
import ChildPoolApr from "../../shared/ChildPoolApr";
import ShareModal from "./models/ShareModal";
import { toast } from "react-toastify";

const Stakingpool = () => {
  const { theme } = useTheme();
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading Staking Pool...");
  const [childPools, setChildPools] = useState();

  const [tokenPrice, setTokenPrice] = useState(0);
  const [totalStakedFormatted, setTotalStakedFormatted] = useState("0.00");
  const [rewardsFormatted, setRewardsFormatted] = useState("0.00");
  const [availableStakes, setAvailableStakes] = useState();
  const [modalType, setModalType] = useState(null);
  const [show, setShow] = useState(false);
  const [value, setValue] = useState("");
  const [bondAmount, setBondAmmount] = useState("0");
  const [txHash, setTxHash] = useState();
  const [totalStakers, setTotalStakers] = useState("0");
  const [poolCount, setPoolCount] = useState(0);
  const [totalRewardClaimed, setTotalRewardClaimed] = useState(0);
  const [isRootPoolActive, setIsRootPoolActive] = useState(true);
  const {apr, bondSize:parentBond, rawTvl} =useParentPoolAPR(childPools?.rootPoolId?.contractAddress, childPools?.rootPoolId?.rewardAmount, childPools?.rootPoolId?.poolEndDate);

  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const id = query.get("id");


  const [showShareModal, setShowShareModal] = useState(false);
  // ✅ Share Modal Handlers
  const handleShowShareModal = () => setShowShareModal(true);
  const handleCloseShareModal = () => setShowShareModal(false);


  const [stakerReward, setStakerReward] = useState("0.00");
  const { address } = useWallet();
  const { ensureAllowance } = useTokenAllowance();
  const { tokenBalance, checkTokenBalance } = useTokenBalance();
  const [tokenSymbol, setTokenSymbol] = useState();
  const [tvlAmount, setTvlAmount] = useState(0);

  const [rawBondAmount, setRawBondAmount] = useState(0);

  // const childAPR = calculateChildPoolAPR(
  //   childPools?.rootPoolId?.rewardAmount,   // might come from parent component
  //   childPools?.rootPoolId?.poolEndDate,              // might be stored separately
  //   tvlAmount,          // from local state
  //   tvlAmount,        // from global context
  //   childPools?.creatorFeePercent           // from pool config
  // );
  // const childAPR = calculateAPR(
  //   childPools?.rootPoolId?.rewardAmount, // might come from parent component
  //   childPools?.rootPoolId?.poolEndDate, // might be stored separately
  //   tvlAmount // from pool config
  // );
  const {
    stake,
    unstake,
    claimRewards,
    claimAndRestake,
    getRewards,
    getTotalStaked,
    getAvailableStakes,
    stakerRewardPerTokenPaid,
  } = useStake();

  const { bondSize } = useBondSize();
  const { price: ethPrice } = useTokenPrice('0x0000000000000000000000000000000000000000');

  const activities = [
    {
      date: "Sep 01, 2025",
      time: "07:02 PM",
      type: "Staked",
      amount: "25,000 OASIS",
      txHash: "0xa3q...5r2",
    },
  ];

  const handleClose = (flag) => {
    if (flag) {
      window.location.reload();
    }
    setShow(false);
  };

  const openModal = (type) => {
    setModalType(type);
    setShow(true);
  };

  /** ------------------------------
   *   Data Fetchers
   * ------------------------------ */
  const fetchPoolCount = useCallback(async () => {
    try {
      if (!childPools?.contractAddress) return;

      const response = await apiRequest({
        url: `${ApiUrl}/pool/pool-count/${childPools?.createdBy?.walletAddress}`,
        method: "GET",
        auth: false,
      });

      setPoolCount(
        response?.data?.activeChildPoolsCount +
          response?.data?.activeRootPoolsCount || 0
      );
    } catch (error) {
      console.error("Failed to fetch pool count:", error);
    }
  }, [childPools]);

  const fetchTotalStakers = useCallback(async () => {
    // toast.info("Fetching total stakers data. This may take a few seconds.");
    try {
      if (!childPools?.contractAddress) return;
      const response = await apiRequest({
        url: unifarmFactory.rootTokens,
        method: "POST",
        data: {
          query: STAKES,
          variables: { where: { contract: childPools?.contractAddress } },
        },
        auth: false,
      });
      const stakeDatas = response?.data?.stakes || [];
      setTotalStakers(stakeDatas.length || "0");
    } catch (error) {
      console.error("Failed to fetch total stakers:", error);
    }
  }, [childPools]);

  const fetchClaimableRewards = useCallback(async () => {
    try {
      const response = await apiRequest({
        url: unifarmFactory.rootTokens,
        method: "POST",
        data: {
          query: CLAIMEDS,
          variables: {
            where: { staker: address, contract: childPools?.contractAddress },
          },
        },
        auth: false,
      });

      const claimData = response?.data?.claimeds || [];
      const decimals = childPools?.rootPoolId?.tokenDecimals || 18;
      const divisor = Math.pow(10, decimals);
      const total = claimData.reduce(
        (acc, item) => acc + parseFloat(item?.reward) / divisor,
        0
      );
      setTotalRewardClaimed(total);
    } catch (error) {
      console.error("Failed to fetch total claimed:", error);
    }
  }, [childPools, address]);

  const fetchChildPools = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    try {
      const data = await apiRequest({
        url: `${ApiUrl}/pool/child-pool/${id}`,
        method: "GET",
        auth: false,
      });

      setTokenSymbol(data?.data?.rootPoolId?.symbol);
      setChildPools(data?.data);
      const rootPoolEndDate = data?.data?.rootPoolId?.poolEndDate;
      const endDate = new Date(rootPoolEndDate);
      const currentDate = new Date();
      const hasRootPoolEnded = endDate <= currentDate;
      // console.log("Rooot POOl end", { endDate, currentDate, hasRootPoolEnded });
      setIsRootPoolActive(!hasRootPoolEnded);
    } catch (error) {
      console.error("Failed to fetch child pools:", error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  const fetchStakerRewardPerTokenPaid = useCallback(async () => {
    if (!childPools?.contractAddress || !address) return;
    try {
      const decimals = childPools?.rootPoolId?.tokenDecimals || 18;
      const reward = await stakerRewardPerTokenPaid(
        childPools?.contractAddress,
        address,
        decimals
      );
      setStakerReward(reward.rewardPerTokenFormatted);
    } catch (error) {
      console.error("Failed to fetch stakerRewardPerTokenPaid:", error);
    }
  }, [childPools, address, stakerRewardPerTokenPaid]);

  const fetchTotalStaked = useCallback(async () => {
    if (!childPools?.contractAddress) return;
    try {
      const decimals = childPools?.rootPoolId?.tokenDecimals || 18;
      const totalStaked = await getTotalStaked(
        childPools?.contractAddress,
        decimals
      );
      setTotalStakedFormatted(totalStaked.totalStakedFormatted);
    } catch (error) {
      console.error("Failed to fetch total staked:", error);
    }
  }, [childPools]);

  const fetchAvailableStakes = useCallback(async () => {
    if (!childPools?.contractAddress || !address) return;
    try {
      const decimals = childPools?.rootPoolId?.tokenDecimals || 18;
      const stakes = await getAvailableStakes(
        childPools?.contractAddress,
        address,
        decimals
      );

      setAvailableStakes({
        amountETH: stakes?.amountETH || "0",
        restakeAmountETH: stakes?.restakeAmountETH || "0",
        claimCountdown: stakes?.claimCountdown || "00D:00H:00M",
        amountNumber: stakes?.amountNumber || 0,
        restakeAmountNumber: stakes?.restakeAmountNumber || 0,
        claimTime: stakes?.claimTime,
      });
    } catch (error) {
      console.error("Failed to fetch available stakes:", error);
      setAvailableStakes({
        amountETH: "0",
        restakeAmountETH: "0",
        claimCountdown: "00D:00H:00M",
        amountNumber: 0,
        restakeAmountNumber: 0,
      });
    }
  }, [childPools, address, getAvailableStakes]);

  const fetchUserRewards = useCallback(async () => {
    if (!childPools?.contractAddress || !address) return;
    try {
      const decimals = childPools?.rootPoolId?.tokenDecimals || 18;
      const rewards = await getRewards(
        childPools?.contractAddress,
        address,
        decimals
      );

      // console.log(rewards, "Rewards");
      setRewardsFormatted(rewards.rewardsFormatted);
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }
  }, [childPools, address, getRewards]);

  const fetchTokenPrice = useCallback(async () => {
    if (!tokenSymbol) return;
    try {
      const data = await fetchPrice(tokenSymbol.toUpperCase());
      setTokenPrice(data.price);
    } catch (error) {
      console.error("Failed to fetch price:", error);
    }
  }, [tokenSymbol]);

  const fetchBondSize = useCallback(async () => {
    if (childPools) {
      try {
        const bond = await bondSize(childPools?.contractAddress);
        setRawBondAmount(bond);
        // console.log(bond, "bondSizebondSize");
        const z = formatUnits(
          bond,
          childPools?.rootPoolId?.tokenDecimals || 18
        );
        // console.log(z, "bondSizebondSize");
        setBondAmmount(z);
      } catch (e) {
        // console.log(e);
      }
    }
  }, [childPools, bondSize]);

  /** ------------------------------
   *   Effects
   * ------------------------------ */
  useEffect(() => {
    fetchChildPools();
  }, [fetchChildPools]);

  useEffect(() => {
    if (childPools?.contractAddress && address) {
      fetchInitialData();
    }
  }, [childPools, address]);

  const fetchInitialData = () => {
    checkTokenBalance(childPools?.rootPoolId?.rewardToken, address);
    fetchStakerRewardPerTokenPaid();
    fetchAvailableStakes();
    fetchTotalStaked();
    fetchUserRewards();
    fetchBondSize();
    
    fetchPoolCount();
    fetchClaimableRewards();
  };

  useEffect(() => {
  
    fetchTokenPrice();
  }, [fetchTokenPrice]);
  useEffect(() => {
  if(childPools?.contractAddress){
    fetchTotalStakers();
  }
  }, [childPools?.contractAddress])
  

  /** ------------------------------
   *   Input Change
   * ------------------------------ */
  const handleChange = (e) => {
    let val = e.target.value;
    if (/^[0-9.,]*$/.test(val)) {
      const dotCount = (val.match(/\./g) || []).length;
      if (dotCount <= 1) {
        setValue(val);
      }
    }
  };

  /** ------------------------------
   *   Confirm Actions
   * ------------------------------ */
  const confirmStake = async () => {
    try {
      handleClose();
      setLoadingText("Checking Allowance...");
      setLoading(true);

      const decimals = childPools?.rootPoolId?.tokenDecimals || 18;

      await ensureAllowance(
        childPools?.rootPoolId?.rewardToken,
        childPools?.contractAddress,
        removeCommas(value)
      );

      setLoadingText("Staking Tokens...");
      const { receipt, hash } = await stake(
        childPools?.contractAddress,
        removeCommas(value),
        decimals
      );
      setTxHash(hash);
      openModal("stakeSuccess");
    } catch (error) {
      console.error("Error during staking:", error);
      setLoadingText("Something went wrong. Please try again.");
      openModal("stakeError");
    } finally {
      setLoading(false);
    }
  };

  const confirmUnstake = async () => {
    try {
      handleClose();
      setLoadingText("Unstaking Tokens...");
      setLoading(true);

      const decimals = childPools?.rootPoolId?.tokenDecimals || 18;

      const { receipt, hash } = await unstake(
        childPools?.contractAddress,
        removeCommas(value),
        decimals
      );
      setTxHash(hash);
      openModal("unstakeSuccess");
    } catch (error) {
      console.error("Error during unstaking:", error);
      setLoadingText("Something went wrong. Please try again.");
      openModal("unstakeError");
    } finally {
      setLoading(false);
    }
  };

  const confirmClaimRewards = async () => {
    try {
      handleClose();
      setLoadingText("Claiming Rewards...");
      setLoading(true);

      const { receipt, hash } = await claimRewards(childPools?.contractAddress);
      setTxHash(hash);
      openModal("claimSuccess");
    } catch (error) {
      console.error("Error during claiming rewards:", error);
      setLoadingText("Something went wrong. Please try again.");
      openModal("claimError");
    } finally {
      setLoading(false);
    }
  };

  const confirmClaimAndRestake = async () => {
    try {
      handleClose();
      setLoadingText("Claiming & Restaking Rewards...");
      setLoading(true);

      const { receipt, hash } = await claimAndRestake(
        childPools?.contractAddress
      );
      setTxHash(hash);
      openModal("restakeSuccess");
    } catch (error) {
      console.error("Error during claim and restake:", error);
      setLoadingText("Something went wrong. Please try again.");
      openModal("restakeError");
    } finally {
      setLoading(false);
    }
  };


  useEffect(()=>{
    // console.log(rawBondAmount, tvlAmount,apr, parentBond, rawTvl, 'bondWei, tvlWei');
    if(childPools?.rootPoolId && rawBondAmount && tvlAmount&& parentBond && rawTvl && apr){
      fun(rawBondAmount, tvlAmount, parentBond,rawTvl,apr);
    }
  },[childPools, rawBondAmount, tvlAmount,apr, parentBond, rawTvl])

  if (loading) {
    return <Loader loadingText={loadingText} />;
  }

  return (
    <>
      <section className="stakingpool_main">
        <div className="layer_imggggs">
          <div className="imgdarklight">
            {theme === "dark" ? (
              <img
                src="/assets/detailshade.png"
                className="imgdarklightt lassst"
              />
            ) : (
              <img src="/assets/bgggg.png" alt="Logo" className="imgdarklightt" />
            )}
          </div>
          {/* <img
            src={childPools?.rootPoolId?.projectLogo}
            className="detailshade"
          /> */}
        </div>

        <div className="custom-container">
          <div className="stakingpool">
            <div className="sideee_bar">
              <h2>{childPools?.tagline}</h2>
              <button className="sharebutton" onClick={handleShowShareModal}>
                <img src="\assets\share.svg" />
              </button>
            </div>
            <p>{childPools?.poolDescription || "No description provided."}</p>

            <div className="top_future non-future">
              <div className="inner_top">
                <img
                  src={childPools?.rootPoolId?.projectLogo}
                  className="imgggline"
                />
                <div>
                  <span>Root Pool</span>
                  <h3>{childPools?.rootPoolId?.projectName}</h3>
                </div>
              </div>
              <span className="greyline"></span>
              <div className="inner_top">
                <img
                  src={
                    childPools?.createdBy.imageUrl ||
                    defaultUserProfile?.imageUrl
                  }
                  className="imgggline"
                />
                <div>
                  <span>Created By</span>
                  <h3>
                    {childPools?.createdBy?.name || defaultUserProfile?.name}
                  </h3>
                </div>
              </div>
            </div>
            <div className="shhhharess">
       {/* <button className="share_butttons">
 {theme === "dark" ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
  <path d="M7.5 1.16666V8.74999" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.83317 3.49999L7.49984 1.16666L5.1665 3.49999" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.8335 7V11.6667C2.8335 11.9761 2.95641 12.2728 3.1752 12.4916C3.394 12.7104 3.69074 12.8333 4.00016 12.8333H11.0002C11.3096 12.8333 11.6063 12.7104 11.8251 12.4916C12.0439 12.2728 12.1668 11.9761 12.1668 11.6667V7" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
            ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
  <path d="M7.5 1.16669V8.75002" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.83366 3.50008L7.50033 1.16675L5.16699 3.50008" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.83301 7V11.6667C2.83301 11.9761 2.95592 12.2728 3.17472 12.4916C3.39351 12.7104 3.69026 12.8333 3.99967 12.8333H10.9997C11.3091 12.8333 11.6058 12.7104 11.8246 12.4916C12.0434 12.2728 12.1663 11.9761 12.1663 11.6667V7" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
            )}
              Share</button> */}
            </div>


            <div className="chart_side">
              <div className="inner_future">
                <p>APR</p>
                <h4><ChildPoolApr childPoolContractAddress={childPools?.contractAddress} rootPoolAddress={childPools?.rootPoolId?.contractAddress} rootPoolEndDate={childPools?.rootPoolId?.poolEndDate} rootPoolRewardAmount={childPools?.rootPoolId?.rewardAmount} rootPoolStartDate={childPools?.rootPoolId?.createdAt}/></h4>
              </div>
              <div className="inner_future">
                <p>TVL</p>
                <h4>
                  <Tvl
                    contractAddress={childPools?.contractAddress}
                    poolType={"childPool"}
                    // setTvlAmount={setTvlAmount}
                    tokenAddress={childPools?.rootPoolId?.rewardToken}
                  />{" "}
                  {/* {tokenSymbol} */}
                </h4>
              </div>
              <div className="inner_future">
                <p>Fees</p>
                <h4>
                  {childPools?.creatorFeePercent + "%" ||
                    "No fees information available."}
                </h4>
              </div>
              <div className="inner_future">
                <p>Total Stakers</p>
                <h4>{totalStakers + " Stakers"}</h4>
              </div>
            </div>

            <div className="head_mains">
              <TabSection
                tokenBalance={tokenBalance}
                tokenSymbol={tokenSymbol}
                value={value}
                handleChange={handleChange}
                setValue={setValue}
                totalStakedFormatted={totalStakedFormatted}
                rewardsFormatted={rewardsFormatted}
                openModal={openModal}
                availableStakes={availableStakes}
                childPools={childPools}
                bondAmount={bondAmount}
                stakerReward={stakerReward}
                walletAddress={childPools?.createdBy?.walletAddress}
                poolCount={poolCount}
                totalRewardClaimed={totalRewardClaimed}
                tokenDecimals={childPools?.rootPoolId?.tokenDecimals || 18}
                isRootPoolActive={isRootPoolActive}
              />

              <ActivitySection
                activities={activities}
                by={address}
                contractAddress={childPools?.contractAddress}
                token={tokenSymbol}
                claimContract={childPools?.claimContract}
                tokenDecimals={childPools?.rootPoolId?.tokenDecimals}
              />
            </div>
          </div>
        </div>
      </section>

      <ModalManager
        modalType={modalType}
        show={show}
        handleClose={handleClose}
        value={value}
        tokenSymbol={tokenSymbol}
        tokenPrice={tokenPrice}
        rewardsFormatted={rewardsFormatted}
        confirmStake={confirmStake}
        confirmUnstake={confirmUnstake}
        confirmClaimRewards={confirmClaimRewards}
        confirmClaimAndRestake={confirmClaimAndRestake}
        feeRate={childPools?.creatorFeePercent}
        ethPrice={ethPrice}
        txHash={txHash}
        availableStakes={availableStakes}
      />

      <ShareModal
        show={showShareModal}
        onHide={handleCloseShareModal}
        poolData={childPools}
        hash={id}
      />
    </>
  );
};

export default Stakingpool;
